module.exports = __webpack_public_path__ + "img/20191022164558562.68f42129.jpg";